import { useState } from "react"

export const useGlobalStates = () => {
    
    //para el formulario
    const [ showFormContract, setShowFormContract ] = useState(false)
    const [ formOpeningMode, setFormOpeningMode ] = useState('EDITABLE')
    const [ stepApplilication, setStepApplilication ]  = useState(0)

    // para la modal
    const [ showModalDeposit, setShowModalDeposit ] = useState(false)
    const [ modalOpeningMode, setModalOpeningMode ] = useState('EDITABLE')


    return Object.freeze({
        showFormContract, setShowFormContract,
        formOpeningMode, setFormOpeningMode,
        showModalDeposit, setShowModalDeposit,
        modalOpeningMode, setModalOpeningMode,
        stepApplilication, setStepApplilication
    })
}